
export { getPmtPage } from "./contentfulAPI/pmtPage.fetchers"
export { getTranslationData } from "./contentfulAPI/translation.fetchers"